"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeVariants = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
function getDefaultTypeStyles(_a) {
    var align = _a.align, bold = _a.bold, caps = _a.caps, margin = _a.margin, padding = _a.padding, semiBold = _a.semiBold, textTheme = _a.textTheme, variant = _a.variant, fontFamily = _a.fontFamily;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    text-align: ", ";\n    color: ", ";\n    margin: ", ";\n    padding: ", ";\n    ", "\n    ", "\n    ", ";\n  "], ["\n    ", "\n    ", "\n    text-align: ", ";\n    color: ", ";\n    margin: ", ";\n    padding: ", ";\n    ", "\n    ", "\n    ", ";\n  "])), b2c_theme_1.typography[variant], caps ? 'text-transform: uppercase;' : '', align, b2c_theme_1.fontTheme[textTheme], margin, padding, semiBold
        ? "font-family: ".concat(b2c_theme_1.fonts.defaultSemibold, "; font-weight: 400;")
        : '', bold ? "font-family: ".concat(b2c_theme_1.fonts.defaultBold, "; font-weight: 500") : '', fontFamily &&
        "font-family: ".concat(fontFamily === 'heading' ? b2c_theme_1.fonts.heading : b2c_theme_1.fonts.default));
}
var HeadingOne = styled_components_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var HeadingTwo = styled_components_1.default.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var HeadingThree = styled_components_1.default.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var HeadingFour = styled_components_1.default.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var HeadingFive = styled_components_1.default.h5(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var HeadingSix = styled_components_1.default.h6(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var TitleXS = styled_components_1.default.h3(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var TitleXXL = styled_components_1.default.h1(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var BodyParagraph = styled_components_1.default.p(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var SpanElement = styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var LegendElement = styled_components_1.default.legend(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n  padding: 0;\n"], ["\n  ", "\n  padding: 0;\n"])), function (props) { return getDefaultTypeStyles(props); });
var LabelSMediumElement = styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
var LabelMMediumElement = styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return getDefaultTypeStyles(props); });
exports.TypeVariants = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    body: 'body',
    bodyLarge: 'bodyLarge',
    bodyXLarge: 'bodyXLarge',
    bodySmall: 'bodySmall',
    titleXS: 'titleXS',
    titleXXL: 'titleXXL',
    span: 'span',
    legend: 'legend',
    labelSMedium: 'labelSMedium',
    labelMMedium: 'labelMMedium',
};
var Typography = function (props) {
    var defaultProps = {
        align: 'inherit',
        allCaps: false,
        bold: false,
        margin: '0',
        padding: '0',
        semiBold: false,
        theme: 'primary',
        variant: exports.TypeVariants.body,
    };
    var _a = __assign(__assign({}, defaultProps), props), align = _a.align, allCaps = _a.allCaps, bold = _a.bold, children = _a.children, component = _a.component, margin = _a.margin, padding = _a.padding, semiBold = _a.semiBold, theme = _a.theme, variant = _a.variant, fontFamily = _a.fontFamily, rest = __rest(_a, ["align", "allCaps", "bold", "children", "component", "margin", "padding", "semiBold", "theme", "variant", "fontFamily"]);
    var componentType = component || variant;
    var Component;
    switch (componentType) {
        case exports.TypeVariants.h1:
            Component = (react_1.default.createElement(HeadingOne, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-one", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.h2:
            Component = (react_1.default.createElement(HeadingTwo, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-two", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.h3:
            Component = (react_1.default.createElement(HeadingThree, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-three", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.h4:
            Component = (react_1.default.createElement(HeadingFour, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-four", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.h5:
            Component = (react_1.default.createElement(HeadingFive, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-five", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.h6:
            Component = (react_1.default.createElement(HeadingSix, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-heading-six", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.titleXS:
            Component = (react_1.default.createElement(TitleXS, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-title-xs", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.titleXXL:
            Component = (react_1.default.createElement(TitleXXL, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-title-xxl", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.span:
            Component = (react_1.default.createElement(SpanElement, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-span", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.legend:
            Component = (react_1.default.createElement(LegendElement, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-legend", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.labelSMedium:
            Component = (react_1.default.createElement(LabelSMediumElement, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-label-s-medium", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        case exports.TypeVariants.labelMMedium:
            Component = (react_1.default.createElement(LabelMMediumElement, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-label-m-medium", margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
        default:
            Component = (react_1.default.createElement(BodyParagraph, __assign({ align: align, bold: bold, fontFamily: fontFamily, caps: allCaps, "data-testid": "typography-".concat(componentType), margin: margin, padding: padding, semiBold: semiBold, variant: variant, textTheme: theme }, rest), children));
            break;
    }
    return Component;
};
exports.default = Typography;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
//# sourceMappingURL=Typography.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Typography/Typography.js
// module id = 142
// module chunks = 81